import { Box, Skeleton } from '@chakra-ui/react'
import React from 'react'

const progressColor = (percent, reversed) => {
  const val = reversed ? 100 - percent : percent
  switch (true) {
    case val > 75:
      return 'brand.error'
    case val > 50:
      return 'brand.warning'
    default:
      return 'brand.success'
  }
}

const sizes = {
  xs: {
    border: '0',
    radius: '0',
    padding: '0',
    height: '3px'
  },
  sm: {
    border: '1px',
    radius: 'full',
    padding: '1px',
    height: '5px'
  },
  md: {
    border: '1px',
    radius: 'full',
    padding: '2px',
    height: '6px'
  },
  lg: {
    border: '1px',
    radius: 'full',
    padding: '2px',
    height: '8px'
  }
}

function ProgressBar({
  percent,
  max = 100,
  value = 1,
  completion,
  reversed,
  size = 'md',
  loading = false,
  color = 'brand.main',
  ...rest
}) {
  percent = isNaN(percent) ? parseInt((100 / parseInt(max, 10)) * value, 10) : percent

  const barColor = completion ? progressColor(percent, reversed) : color
  const { border, radius, padding, height } = sizes[size] || size.sm
  return (
    <Box w="full" pos="relative" borderWidth={border} borderRadius={radius} p={padding} {...rest}>
      {loading ? (
        <Skeleton h={height} w="100%" pos="relative" borderRadius={radius} zIndex="1" />
      ) : (
        <Box
          pos="relative"
          h={height}
          bg={barColor}
          borderRadius={radius}
          style={{ width: `${percent}%` }}
          transition="width .225s ease"
          zIndex="1"
        />
      )}
      {size !== 'sm' && (
        <Box
          pos="absolute"
          top={padding}
          bottom={padding}
          left={padding}
          right={padding}
          borderRadius={radius}
          bg="brand.progress"
          opacity="0.8"
        />
      )}
    </Box>
  )
}

export default ProgressBar
